import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=06ce799a&"
import script from "./Consultations.vue?vue&type=script&lang=js&"
export * from "./Consultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ce799a')) {
      api.createRecord('06ce799a', component.options)
    } else {
      api.reload('06ce799a', component.options)
    }
    module.hot.accept("./Consultations.vue?vue&type=template&id=06ce799a&", function () {
      api.rerender('06ce799a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/SCT/Consultations.vue"
export default component.exports